export default __webpack_public_path__ + "static/Condominiali-db16a75e07e744625c84614525e5a6cf.jpg";